import { Typography, Box, Grid2 as Grid, Container } from "@mui/material";
import { receiveStatus } from "../../util/receiveStatus";
import ReceiveCard from "./ReceiveCard";
import { useStyles } from "./Receive.styles";
import { ReceiveCardListProps } from "./types";
import TransferCard from "../Transfer/TransferCard/TransferCard";

export default function ReceiveCardList({ receives, title, message, onView }: ReceiveCardListProps) {
	const classes = useStyles();

	return (
		<Container disableGutters>
			{title && <Typography className={classes.statusTitle}>{title}</Typography>}
			<Typography variant="body1" display="inline">
				{title==="Issues"? receives.length + " receive" + (receives.length !== 1 ? "s" : "") + " with issues": receives.length + " " + message}
			</Typography>

			<Grid container direction="column" wrap={"nowrap"} className={classes.receiveCardContainer}>
				{receives.map((receive) => {
					if (receive.purchaseOrderNumber) {
						if (
							receive.receiveStatus === receiveStatus.pendingFinalise &&
							!receive.failureReason &&
							receive.latestStatusHistory &&
							new Date().getTime() - Date.parse(receive.latestStatusHistory.timestamp) < 5 * 60 * 1000
						) {
							return null;
						}
						return (
							<Grid size="grow" key={`${receive.id}`}>
								<ReceiveCard
									id={receive.id}
									purchaseOrderNumber={receive.purchaseOrderNumber}
									invoiceNumber={receive.invoiceNumber}
									store={receive.store}
									supplier={receive.supplier}
									receiveType={receive.receiveType || ""}
									invoiceType={receive.invoiceType}
									onView={onView}
									receiveStatus={receive.receiveStatus}
									isDisabled={receive.isDisabled}
									totalCostInc={receive.totalCostInc}
									totalQty={receive.totalQty}
									failureReason={receive.failureReason || ""}
									latestStatusHistory={receive.latestStatusHistory}
									hours={receive.hours}
									dateCreated={receive.dateCreated}
									createdBy={receive.createdBy}
								/>
							</Grid>
						);
					} else if (receive.transfer && receive.transfer.sourceId) {
						return (
							<Grid size="grow" key={`${receive.id}`}>
								<TransferCard
									receiveStatus={receive?.receiveStatus || receiveStatus.open}
									receiveDateCreated={receive.dateCreated}
									receiveCreatedBy={receive.createdBy}
									displayMode="ReceiveList"
									transfer={receive.transfer}
								/>
							</Grid>
						);
					}
					return null;
				})}
			</Grid>
		</Container>
	);
}
